// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestShareRouteImport } from './routes/test-share'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as AgendamentoRouteImport } from './routes/agendamento'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicosIndexRouteImport } from './routes/servicos.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as ServicosSlugRouteImport } from './routes/servicos.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const TestShareRoute = TestShareRouteImport.update({
            id: '/test-share',path: '/test-share',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const AgendamentoRoute = AgendamentoRouteImport.update({
            id: '/agendamento',path: '/agendamento',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicosIndexRoute = ServicosIndexRouteImport.update({
            id: '/servicos/',path: '/servicos/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const ServicosSlugRoute = ServicosSlugRouteImport.update({
            id: '/servicos/$slug',path: '/servicos/$slug',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AgendamentoRoute: AgendamentoRoute,ContatoRoute: ContatoRoute,DashboardRoute: DashboardRoute,SobreRoute: SobreRoute,TestShareRoute: TestShareRoute,BlogSlugRoute: BlogSlugRoute,ServicosSlugRoute: ServicosSlugRoute,BlogIndexRoute: BlogIndexRoute,ServicosIndexRoute: ServicosIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)